import * as API from '@common/api/theme'
import * as T from './types'

export default {
    [T.GET_THEME_LIST]({ commit }, payload) {
        commit(T.SET_THEME_LOADING, true)
        return API.getThemeList(payload).then(data => {
            if (data) {
                commit(T.SET_THEME_LIST, data ?? [])
                const selected = data.find(i => i.isSelect)
                if (selected) {
                    commit(T.SET_CURRENT_THEME_ID, selected.id)
                    commit(T.SET_CURRENT_THEME, selected)
                }
            }
        }).finally(() => {
            commit(T.SET_THEME_LOADING, false)
        })
    },
    [T.GET_THEME_BY_ID](store, payload) {
        return API.getThemeById(payload)
    },
    [T.GET_DEFAULT_THEME](store, payload) {
        return API.getDefaultTheme(payload)
    },
    [T.ADD_THEME](store, payload) {
        return API.addTheme(payload)
    },
    [T.UPDATE_THEME](store, payload) {
        const { id, ...others } = payload
        return API.updateTheme(id, others)
    },
    [T.DELETE_THEME](store, payload) {
        return API.deleteTheme(payload)
    },
    [T.GET_SELECTED_THEME](store, payload) {
        return API.getSelectedTheme(payload)
    },
    [T.SET_SELECTED_THEME]({ commit, state }, payload) {
        return API.setSelectedTheme(payload).then(() => {
            const { themeList = [] } = state
            const cur = themeList.find(i => i.id === payload)

            commit(T.SET_CURRENT_THEME_ID, payload)
            commit(T.SET_CURRENT_THEME, cur)
        })
    },
    [T.UPDATE_THEME_TITLE](store, payload) {
        const { id, ...others } = payload
        return API.updateThemeTitle(id, others)
    },
    
}
